import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import axios from 'axios';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import validator from 'validator';
import { Card, Dropdown, Grid, Icon, Button, Popup, Divider, Label, Radio } from 'semantic-ui-react';
import {
  DyzioPrimaryButton,
  DyzioSecondaryButton,
  DyzioDeleteButton,
} from 'dyzio-shared-components/lib/components/dyzio-buttons';

import { TIKTOK } from '../../utils/static-configuration';

import { authService } from '../../utils/auth-service';
import { getShopifyOrdersByDiscussionId } from '../../hocs/has-shopify';
import { getPrestaShopOrdersByDiscussionId } from '../../hocs/has-prestaShop';
import hasRESTClient from '../../hocs/has-rest-client';
import { loadingCampaign } from '../../containers/campaign/actions';
import hasJSONAPIClient from '../../hocs/has-jsonapi-client';
import hasUserInfo from '../../hocs/has-user-info';
import withTrackedAssetsData from '../../hocs/data/with-tracked-assets-data';
import VerticalInfluencerBar from '../../components/vertical-influencer-bar';
import { checkUserIsTeamMember } from '../../utils/role-service';
import { getTrackedAssetAnalytics } from '../../utils/tracked-assets-analytics-service';
import AddAssetForm from '../../components/add-asset-form';
import AssetTable from '../../components/asset-table';
import ShopifyTable from '../../components/shopify-table';
import DeleteInfluencerModal from '../../components/delete-influencer-modal';
import InviteModal2 from '../../components/invite-modal2';
import AddStoryModal from '../../components/add-story-modal';
import sendLimitsExceededNotification from '../../utils/send-limits-exceeded-notifcation';
import InvitationStatus from '../../components/invitation-status';
import CollaborationBudget from '../../components/collaboration-budget';
import CollaborationEmail from '../../components/collaboration-email';
import BlockedInvitationStatus from '../../components/blocked-invitation-status';
import LinkTracking from '../../components/link-tracking';
import ShopifyConfig from '../../components/shopify-config';

import PrestaShopConfig from '../../components/prestaShop-config';
import PrestaShopTable from '../../components/prestaShop-table';

import StoryPickerModal from '../../containers/story-picker-modal';
import ScanHistoryModal from '../../components/scan-history-modal';
import ScanNowModal from '../../components/scan-now-modal';
import RollForwardModal from '../../components/roll-forward-modal';

import ThemeSelector from '../../themes/theme-selector';
const currentTheme = ThemeSelector.theme();

const ENFORCE_LIMITS = false;
const INFLUENCER_LIMIT = 200;

const WAIT_FOR = 2000;
const ASSET_API_TIMEOUT = 3500;

const tiktokIconStyle = {
  width: 15,
  marginTop: 2,
};

const loadingAssetsCardStyle = {
  padding: '120px 0',
  color: 'gray',
};

const backButtonStyle = {
  border: '0px solid #1d1937',
};

const buttonStyles = {
  width: 'auto',
};

const smallPrint = {
  'font-size': '0.75em',
};

const assetInitialState = {
  adding: false,
  platform: null,
  url: null,
  errors: {
    url: false,
  },
};

class Collaboration extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor(props) {
    super(props);
    const {
      location: {
        state: {
          rollfwdCampaign,
        },
      },
    } = props;

    let rollForwardModal;
    if (rollfwdCampaign) {
      rollForwardModal = {
        visible: false,
        selected: {
          id: rollfwdCampaign.id,
          title: rollfwdCampaign.name,
        },
        options: [],
        isSearching: false,
        searched: false,
      };
    } else {
      rollForwardModal = {
        visible: false,
        selected: null,
        options: [],
        isSearching: false,
        searched: false,
      };
    }


    this.state = {
      isLoadingLiveStoriesCount: true,
      liveStoriesCount: 0,
      isLoadingCollaboration: true,
      collaboration: null,
      notes: null,
      isLoadingAssets: true,
      isDeletingInfluencer: false,
      deleting: false,
      sendingInvite: false,
      feeModalOpen: false,
      inviteSentOK: false,
      viewLiveStoriesModalOpen: false,
      modalInvitation: null,
      invitationSent: false,
      status: 'initial',
      localInvitatinStatus: null,
      addStoryVisible: false,
      assetsDetails: [],
      asset: _.clone(assetInitialState),
      requiresCampaignReload: false,
      newEmail: null,
      temporaryAsset: null,
      isAddingStoryToCollab: false,
      scanHistoryModalOpen: false,
      scanNowModalOpen: false,
      rollForwardModalOpen: false,
      hasRolledForward: false,
      nextDiscussionId: null,
      previousDiscussionId: null,
      isRolling: false,
      rollForwardModal,
      shopifyOrders: [],
      prestaSHopOrders: [],
      shopifyLoading: true,
      isClientDiscussion: false,
      isScanningCompleted: false,
      createDiscountDisabled: false,
      createDiscountLoading: false,
      newShortLink: null,
    };
  }

  componentDidMount = async () => {
    const collaboration = await this.loadCollaboration();
    const { notes } = collaboration;
    const influencerOrganisation = _.find(collaboration.organisations, org => _.eq(org.orgType, 'INFLUENCER'));
    this.setState({
      collaboration,
      isClientDiscussion: _.get(collaboration, 'isClientDiscussion', false),
      isScanningCompleted: _.get(collaboration, 'isScanningCompleted', false),
      nextDiscussionId: _.get(collaboration, 'nextDiscussion.id', null),
      previousDiscussionId: _.get(collaboration, 'previousDiscussion.id', null),
      notes,
      influencer: influencerOrganisation.influencer,
      isLoadingCollaboration: false,
      asset: _.clone(assetInitialState),
    }, this.fetchTrackedAssetsData);

    const { buildRESTClient } = this.props;
    const influencerId = influencerOrganisation.influencer.id;

    this.loadShopify();

    if (influencerId) {
      const restClient = buildRESTClient({
        baseURL: process.env.REACT_APP_STORY_SERVICE_API,
      });
      const response = await restClient.get(`stories/by-influencer/${influencerId}`);
      if (response) {
        const stories = _.get(response, 'data.data', []);
        this.setState({
          liveStoriesCount: _.size(stories),
          isLoadingLiveStoriesCount: false,
        });
      }
    }
  }

  loadCollaboration = async () => {
    const {
      jsonAPIClient,
      params: { collabId },
    } = this.props;
    const response = await jsonAPIClient.get('discussions', collabId, {
      include: [
        'inventoryItems',
        'trackedAssets',
        'trackedAssets.supportingData',
        'stories',
        'stories.supportingData',
        'organisations',
        'organisations.influencer',
        'organisations.influencer.telegramChannels',
        'organisations.influencer.telegramUser',
        'nextDiscussion',
        'previousDiscussion',
      ],
    });
    return response.toJSONTree();
  }

  loadShopify = async () => {
    const {
      params: { collabId },
      userInfo: { organisationId },
    } = this.props;
    const {
      influencer,
    } = this.state;
    this.setState({ shopifyLoading: true });
    const discountCode = _.get(influencer, 'discountCode');
    const { orders } = await getShopifyOrdersByDiscussionId({ discussionId: collabId, discountCode, organisationId });
    const prestaShop = await getPrestaShopOrdersByDiscussionId({ discussionId: collabId, discountCode, organisationId });
    this.setState({ shopifyLoading: false, shopifyOrders: orders, prestaSHopOrders: _.get(prestaShop, 'orders') });
    console.log('shopifyOrders', orders);
  }

  addStoryToCollaboration = async story => {
    this.setState({
      isAddingStoryToCollab: true,
    });
    const { params: { id: campaignId, collabId: discussionId }, buildRESTClient } = this.props;
    const restClient = buildRESTClient({
      baseURL: process.env.REACT_APP_CAMPAIGN_AUTOMATION_URL,
    });
    await restClient.post(`campaign/${campaignId}/discussion/${discussionId}/story`, {
      data: story,
    });
    const collaboration = await this.loadCollaboration();
    this.setState({
      collaboration,
      isAddingStoryToCollab: false,
    });
  }


  fetchTrackedAssetsData = async () => {
    const { collaboration: { trackedAssets }, temporaryAsset } = this.state;

    if (temporaryAsset && temporaryAsset.id) {
      trackedAssets.push(temporaryAsset);
    }

    const noAnalyticsPlatforms = [TIKTOK, 'SNAPCHAT', 'VK', 'BLOG', 'TELEGRAM'];
    const NOT_FOUND = 'NOT_FOUND';

    const isNoAnalyticsPlatform = asset => _.includes(noAnalyticsPlatforms, asset.platform);
    const isNotViable = asset => isNoAnalyticsPlatform(asset) || (asset.fetchStatus === NOT_FOUND);

    const goodAssets = _.filter(trackedAssets, 'platform');
    const trackedAssetsForAnalytics = _.reject(goodAssets, asset => isNotViable(asset));
    const trackedAssetsWithoutAnalytics = _.filter(goodAssets, asset => isNoAnalyticsPlatform(asset));
    const trackedAssetsNotFound = _.filter(goodAssets, { fetchStatus: NOT_FOUND });

    if (trackedAssetsNotFound && trackedAssetsNotFound.length) {
      // eslint-disable-next-line no-restricted-syntax
      for (const asset of trackedAssetsNotFound) {
        trackedAssetsWithoutAnalytics.push({
          trackedAsset: {
            id: asset.id,
            assetURL: asset.assetURL || '',
            platform: asset.platform,
          },
          notFound: true,
        });
      }
    }

    if (trackedAssetsForAnalytics && trackedAssetsForAnalytics.length) {
      getTrackedAssetAnalytics(trackedAssetsForAnalytics)
        .then(response => {
          const assetsDetails = _.map(response, row => {
            const data = row.response.data;
            if (!data || !data.trackedAsset) {
              return {
                trackedAsset: {
                  id: row.id,
                  assetURL: row.assetURL || '',
                },
                withError: true,
              };
            }
            data.trackedAsset = _.find(trackedAssetsForAnalytics, { assetId: data.trackedAsset.assetId });
            return data;
          });
          return this.setState({
            assetsDetails: _.concat(trackedAssetsWithoutAnalytics, assetsDetails),
            isLoadingAssets: false,
            temporaryAsset: null,
          });
        });
    } else {
      return this.setState({
        assetsDetails: trackedAssetsWithoutAnalytics,
        isLoadingAssets: false,
        temporaryAsset: null,
      });
    }
  }

  toggleInfluencerDeleteModal = () => {
    this.setState({
      isDeletingInfluencer: !this.state.isDeletingInfluencer,
    });
  }

  onNewFeeSubmit = async fee => {
    const { jsonAPIClient, params: { collabId } } = this.props;
    const collaboration = await jsonAPIClient.get('discussions', collabId);
    collaboration.set('budget', fee);
    collaboration.set('budgetStatus', 'APPROVED');
    return collaboration.sync();
  }

  onNewEmailSubmit = async email => {
    const { influencer: fullInfluencer } = this.state;
    const { jsonAPIClient } = this.props;
    const influencer = await jsonAPIClient.get('influencer', fullInfluencer.id);
    influencer.set('email', email);

    this.setState({
      newEmail: email,
    });
    return influencer.sync();
  }

  toggleIsClientDiscussion = async () => {
    const { jsonAPIClient, params: { collabId } } = this.props;
    const collaboration = await jsonAPIClient.get('discussions', collabId);
    const { isClientDiscussion } = this.state;
    collaboration.set('isClientDiscussion', !isClientDiscussion);

    this.setState({
      isClientDiscussion: !isClientDiscussion,
    });

    console.log('isClientDiscussion', this.state.isClientDiscussion);

    return collaboration.sync();
  }


  toggleIsScanningCompleted = async () => {
    const { jsonAPIClient, params: { collabId } } = this.props;
    const collaboration = await jsonAPIClient.get('discussions', collabId);
    const { isScanningCompleted } = this.state;
    collaboration.set('isScanningCompleted', !isScanningCompleted);

    this.setState({
      requiresCampaignReload: true,
      isScanningCompleted: !isScanningCompleted,
    });

    console.log('isScanningCompleted', this.state.isScanningCompleted);

    return collaboration.sync();
  }

  onShopifySubmit = async shopifySettings => {
    console.log('shopifySettings', shopifySettings);
    const { jsonAPIClient, params: { collabId } } = this.props;
    const collaboration = await jsonAPIClient.get('discussions', collabId);
    const { discountCode, commission } = shopifySettings;
    if (discountCode) {
      collaboration.set('discountCode', discountCode);
    } else if (_.isEqual(discountCode, '')) {
      collaboration.set('discountCode', ' ');
    }
    if (commission) {
      collaboration.set('commission', commission);
    }
    return collaboration.sync();
  }

  toggleAddStoryModal = () => {
    const { addStoryVisible } = this.state;
    this.setState({ addStoryVisible: !addStoryVisible });
  }

  toggleScanHistoryModal = () => {
    this.setState(prevState => ({
      scanHistoryModalOpen: !prevState.scanHistoryModalOpen,
    }));
  }

  addStory = asset => {
    const { assetsDetails } = this.state;
    assetsDetails.push({
      text: 'fetching data...',
      state: 'FETCHING',
      trackedAsset: asset,
    });

    this.setState({
      assetsDetails,
      requiresCampaignReload: true,
      temporaryAsset: asset,
    });

    setTimeout(() => {
      this.fetchTrackedAssetsData();
    }, ASSET_API_TIMEOUT);
  }

  viewDiscussion = discussion => () => {
    this.context.router.push(`/campaign/discussion/${discussion.get('id')}`);
  };

  removeCollaboration = async () => {
    const { jsonAPIClient } = this.props;
    const { collaboration } = this.state;
    const { id: collaborationId, invitations, members, campaign: { id: campaignId } } = collaboration;
    const invite = _.head(invitations);
    const hasJoined = !_.isEmpty(members);
    const membership = _.head(members);

    const campaign = await jsonAPIClient.get('campaigns', campaignId);
    const discussion = await jsonAPIClient.get('discussions', collaborationId);
    campaign.relationships('discussions').remove(discussion);

    await campaign.sync();
    await discussion.delete();

    if (hasJoined) {
      const { id: permissionId } = membership;
      const permission = await jsonAPIClient.get('campaignPermission', permissionId);
      await permission.delete();
    } else {
      const { id: invitationId } = invite;
      const invitation = await jsonAPIClient.get('campaignInvitation', invitationId);
      await invitation.delete();
    }

    window.open(`/campaign/${campaignId}/collaborations`, '_self');
  };

  toggleAddAssetPopup = (e, data) => {
    const { asset, hasCheckedLimitNotification } = this.state;
    asset.adding = !asset.adding;
    asset.platform = _.isUndefined(data) ? null : data.value;
    if (!hasCheckedLimitNotification) {
      this.checkLimitsNotification();
    }
    this.setState({
      asset,
      hasCheckedLimitNotification: true,
    });
  };

  checkLimitsNotification = () => {
    if (ENFORCE_LIMITS) {
      const { restClient, userInfo: { organisationId, name, userId }, organisation } = this.props;
      if (!trackedAssetsCount || !organisation) return;
      if (trackedAssetsCount < organisation.licenseTrackedAssetLimit) return;
      sendLimitsExceededNotification(restClient, {
        data: {
          name: `${name} `,
          organisationId,
          userId,
          organisationName: `${organisation.name} `,
          assetType: 'tracked assets',
          licenseSubscriptionType: organisation.licenseSubscriptionType,
          url: window.location.href,
        },
      });
    }
  }


  toggleViewLiveStoriesModal = () => this.setState({
    viewLiveStoriesModalOpen: !this.state.viewLiveStoriesModalOpen,
  })

  assetFormSubmitHandler = async asset => {
    const { collaboration, influencer } = this.state;
    const instagramAccountId = influencer.instagramId;


    const {
      createTrackedAsset,
      syncTrackedAssetAndDiscussion,
      campaign,
    } = this.props;

    const data = {
      campaignId: campaign.get('id'),
      discussionId: collaboration.id,
      discussionName: collaboration.name,
      instagramAccountId,
      ...asset,
    };

    const newTrackedAsset = await createTrackedAsset(data);
    const { id: trackedAssetId } = newTrackedAsset;

    await syncTrackedAssetAndDiscussion({
      discussionId: collaboration.id,
      trackedAssetId,
    });

    // close the modal before waiting

    const { assetsDetails } = this.state;
    assetsDetails.push({
      text: 'fetching data...',
      state: 'FETCHING',
      trackedAsset: asset,
    });

    const collaborationClone = _.clone(collaboration);
    collaborationClone.trackedAssets.push(newTrackedAsset);
    this.setState({
      collaboration,
      assetsDetails,
      requiresCampaignReload: true,
      asset: {
        adding: false,
        platform: null,
      },
    }, () => { setTimeout(this.fetchTrackedAssetsData, WAIT_FOR); });
  }

  removeAsset = async (event, { value }) => {
    const {
      removeTrackedAssetById,
      removeTrackedAssetFromDiscussionById,
    } = this.props;
    const { collaboration } = this.state;
    const discussionId = collaboration.id;
    const { id: trackedAssetId } = value.trackedAsset;
    await removeTrackedAssetFromDiscussionById({
      discussionId,
      trackedAssetId,
    });
    await removeTrackedAssetById(trackedAssetId);
    const collaborationClone = _.clone(collaboration);
    const updatedTrackedAssets = _.reject(collaborationClone.trackedAssets, ['id', trackedAssetId]);
    collaborationClone.trackedAssets = updatedTrackedAssets;
    this.setState({
      collaboration: collaborationClone,
      requiresCampaignReload: true,
    }, this.fetchTrackedAssetsData);
  }

  removeStory = async storyId => {
    const { restClient } = this.props;
    const { collaboration } = this.state;
    const { stories } = collaboration;
    const updatedStories = _.reject(stories, ['id', storyId]);
    await restClient.patch(`discussions/${collaboration.id}/relationships/stories`, {
      data: _.map(updatedStories, story => ({ type: 'stories', id: story.id })),
    });
    await restClient.patch(`stories/${storyId}`, {
      data: {
        type: 'stories',
        id: storyId,
        attributes: {
          discussion: null,
          campaign: null,
        },
      },
    });
    collaboration.stories = updatedStories;
    this.setState({
      collaboration,
    });
  }

  toggleSendInviteModal = () => {
    const { influencer: fullInfluencer } = this.state;
    const { campaign, restClient } = this.props;
    const { id } = campaign.toJSON();

    const query = `?filter[campaign]=${id}&page[limit]=${INFLUENCER_LIMIT}`;
    const url = `${process.env.REACT_APP_API_BASE_URL}/campaignInvitation${query}`;

    return restClient.get(url)
      .then(response => response.data.data)
      .then(invitations => {
        const modalInvitation = _.find(invitations, [
          'attributes.metadata.influencerId',
          fullInfluencer.id,
        ]);

        if (modalInvitation) {
          this.setState({
            modalInvitation,
            sendingInvite: true,
            sendingError: false,
            invitationSent: true,
            requiresCampaignReload: true,
          });
        }
      });
  }

  closeInviteModal = () => {
    this.setState({
      modalInvitation: null,
      sendingInvite: false,
      sendingError: false,
      inviteSentOK: false,
    });
  }

  getUserIdFromInvitation = invitation => {
    const { user } = invitation.relationships;
    return user && user.data ? user.data.id : null;
  }

  sendInviteToInfluencer = async ({ data }) => {
    const { modalInvitation, influencer } = this.state;
    const userId = this.getUserIdFromInvitation(modalInvitation);
    if (userId) {
      await this.patchUser({ influencer, userId });
    }
    await this.patchCampaignInvitation({ modalInvitation, influencer, data });
    this.closeInviteModal();
  }

  patchUser = params => {
    const { influencer, userId } = params;
    const { restClient } = this.props;
    const patch = {
      data: {
        type: 'users',
        id: userId,
        attributes: {
          email: influencer.email,
        },
      },
    };
    const url = `${process.env.REACT_APP_API_BASE_URL}/users/${userId}`;
    return restClient.patch(url, patch);
  }

  patchCampaignInvitation = params => {
    const { modalInvitation, influencer, data } = params;
    const { restClient, onLoadingCampaign } = this.props;

    const {
      campaign,
      userInfo: {
        name,
      },
    } = this.props;

    const { collaboration: { campaign: { id: campaignId } } } = this.state;

    const { origin } = window.location;
    const campaignName = campaign.get('name');
    const { shortId } = modalInvitation.attributes;
    const link = `${origin}/invite/${shortId}`;

    const anyAttributes = {
      status: 'SENT',
      email: influencer.email,
      origin,
      notes: data.notes,
      extraData: data,
      name: _.trim(influencer.name),
      campaignName,
      link,
      createdBy: name,
      sentCount: 1,
    };

    const attributes = _.pickBy(anyAttributes);
    const patch = {
      data: {
        type: 'campaignInvitation',
        id: modalInvitation.id,
        attributes,
      },
    };

    const url = `${process.env.REACT_APP_API_BASE_URL}/campaignInvitation/${modalInvitation.id}`;
    restClient.patch(url, patch).then(() => {
      this.setState({
        sendingError: false,
        modalInvitation: null,
        inviteSentOK: true,
      }, () => {
        this.setState({
          localInvitatinStatus: 'SENT',
          requiresCampaignReload: true,
        }, () => onLoadingCampaign(campaignId, true));
      });
    }).catch(error => {
      this.setState({
        updatingInvitationStatusError: error,
        sendingInvite: false,
        sendingError: false,
        inviteSentOK: false,
        modalInvitation: null,
        hideAssetTable: false,
        hideShopifyTable: false,
      });
    });
  }

  toggleFeeModalState = () => {
    this.setState(prevState => ({
      feeModalOpen: !prevState.feeModalOpen,
    }));
  }

  returnToCampaign = () => {
    const {
      router,
      onLoadingCampaign,
    } = this.props;

    const {
      requiresCampaignReload,
      collaboration: {
        campaign: {
          id: campaignId,
        },
      },
    } = this.state;

    if (requiresCampaignReload) {
      onLoadingCampaign(campaignId, true);
    }
    router.goBack();
  }

  toggleAssetLocalState = (assetId, value) => {
    const { assetsDetails, collaboration } = this.state;
    const updatedAssetsDetails = _.map(assetsDetails, asset => {
      if (_.get(asset, 'trackedAsset.id') === assetId) {
        _.set(asset, 'trackedAsset.favourite', value);
      }
      if (_.get(asset, 'id') === assetId) {
        _.set(asset, 'favourite', value);
      }
      return asset;
    });
    const updatedStories = _.map(_.get(collaboration, 'stories', []), story => {
      if (_.get(story, 'id') === assetId) {
        _.set(story, 'favourite', value);
      }
      return story;
    });

    const updatedCollaboration = _.clone(collaboration);
    updatedCollaboration.stories = updatedStories;

    this.setState({
      collaboration: updatedCollaboration,
      assetsDetails: updatedAssetsDetails,
    });
  }

  markAuthorised = () => {
    const { influencer } = this.state;
    const { restClient } = this.props;

    const patch = {
      data: {
        attributes: {
          instagramStatus: 'AUTHORIZED',
          instagramAuthorised: true,
        },
      },
    };

    const url = `${process.env.REACT_APP_API_BASE_URL}/influencer/${influencer.id}`;
    return restClient.patch(url, patch).then(() => {
      window.location.reload(true);
    });
  }

  reloadPage = () => window.location.reload()

  scanNow = async ({ captureAll }) => {
    const {
      campaign,
      params: { collabId },
    } = this.props;


    await this.setState({ scanNowModalOpen: true });
    const campaignId = campaign.get('id');

    console.log('SCAN IT NOW');
    console.log(campaignId);
    console.log(collabId);
    const ax = axios.create({
      baseURL: process.env.REACT_APP_AUTOMATION_API,
      timeout: 30000,
      headers: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });

    let scanUrl = `/run-automated-scan/${campaignId}/discussion/${collabId}`;
    if (captureAll) scanUrl += '?cas=true';
    return ax.post(scanUrl)
      .then(() => this.setState({
        scanNowModalOpen: false,
      }, this.reloadPage))
      .catch(e => {
        console.log(e.message);
        return this.reloadPage();
      });
  }

  toggleRollForwardModal = (hasRolledForward = false) => {
    const { rollForwardModalOpen } = this.state;


    this.setState({
      rollForwardModalOpen: !rollForwardModalOpen,
      hasRolledForward,
    });
  }


  captureAllStories = async () => {
    const captureAll = true;
    await this.scanNow({ captureAll });
  }

  handleRollForwardModalSearch = _.debounce((event, data) => {
    const { value } = data;
    const { cloneModal } = this.state;

    if (!value) {
      const cloneModalUpdated = _.assign(cloneModal, { isSearching: false, searched: false });
      this.setState({ cloneModal: cloneModalUpdated });
      return;
    }

    const cloneModalUpdated = _.assign(cloneModal, { isSearching: true });

    this.setState({
      cloneModal: cloneModalUpdated,
    }, () => this.searchCampaigns(value));
  }, 1000);

  searchCampaigns = value => {
    const { restClient, userInfo: { organisationId } } = this.props;
    const encodedValue = encodeURI(value);
    const searchUrl = `/campaigns?filter[name]=:${encodedValue}&filter[owner]=${organisationId}`;
    restClient.get(searchUrl).then(response => {
      const { data: { data } } = response;
      const options = _.map(data, campaign => ({
        title: `${campaign.attributes.name} [${campaign.attributes.brand}]`,
        id: campaign.id,
      }));
      const { rollForwardModal } = this.state;
      const updated = _.assign(rollForwardModal, {
        options,
        isSearching: false,
        searched: true,
      });
      this.setState({
        rollForwardModal: updated,
      });
    }).catch(error => {
      console.log(error);
    });
  }


  handleOptionsSelected = (event, data) => {
    const { result } = data;
    const { rollForwardModal } = this.state;
    const updated = _.assign(rollForwardModal, { selected: result });
    this.setState({
      rollForwardModal: updated,
    });
  }

  handleRollForwardButton = async (event, data) => {
    const { rollForwardModal, collaboration, influencer } = this.state;

    this.setState({
      isRolling: true,
      requiresCampaignReload: true,
    });

    console.log(rollForwardModal.selected);
    const influencerFields = ['id', 'instagram', 'instagramId', 'tiktok', 'tiktokId', 'email', 'name'];
    const rollForwardPayload = {
      data: {
        campaign: rollForwardModal.selected,
        discussion: {
          id: collaboration.id,
        },
        influencer: _.pick(influencer, influencerFields),
      },
    };

    console.log(rollForwardPayload);

    const ax = axios.create({
      baseURL: 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/influencer',
      timeout: 30000,
      headers: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });

    await ax.post('rollfwd', rollForwardPayload);
    const hasRolledForward = true;
    this.toggleRollForwardModal(hasRolledForward);
  }

  createDiscountLink = async () => {
    this.setState({
      createDiscountDisabled: true,
      createDiscountLoading: true,
    });

    const {
      campaign,
      params: { collabId },
    } = this.props;

    const campaignId = campaign.get('id');
    let shortLinkApi = 'https://bahhjuaz6d.execute-api.eu-west-1.amazonaws.com/production';
    shortLinkApi += `/shortlink/${campaignId}/discussion/${collabId}`;
    console.log(shortLinkApi);
    const response = await axios.post(shortLinkApi);

    console.log(response.data.shortLink);
    this.setState({
      createDiscountDisabled: false,
      createDiscountLoading: false,
      newShortLink: response.data.shortLink,
    });
  }


  render() {
    const {
      location: {
        state: {
          influencer,
          invitationStatus,
          rollfwdCampaign,
        },
      },
      campaign,
      userInfo: {
        role,
        isUserSuperAdmin,
        organisationId,
        isDyzioUser,
      },
      params: { collabId },
    } = this.props;

    const {
      isLoadingCollaboration,
      collaboration,
      influencer: fullInfluencer,
      assetsDetails,
      isLoadingAssets,
      asset,
      addStoryVisible,
      sendingInvite,
      inviteSentOK,
      isDeletingInfluencer,
      localInvitatinStatus,
      newEmail,
      viewLiveStoriesModalOpen,
      isAddingStoryToCollab,
      isLoadingLiveStoriesCount,
      liveStoriesCount,
      scanHistoryModalOpen,
      scanNowModalOpen,
      rollForwardModalOpen,
      rollForwardModal,
      hideAssetTable,
      hideShopifyTable,
      shopifyOrders,
      prestaSHopOrders,
      shopifyLoading,
      isClientDiscussion,
      isScanningCompleted,
      hasRolledForward,
      nextDiscussionId,
      previousDiscussionId,
      isRolling,
      createDiscountDisabled,
      createDiscountLoading,
      newShortLink,
    } = this.state;
    const isOverLimit = false;
    const campaignId = campaign.get('id');
    const campaignName = campaign.get('name');
    const campaignType = campaign.get('campaignType');
    const baseTrackingUrl = campaign.get('baseTrackingUrl');
    const hasBaseTrackingUrl = !_.isEmpty(baseTrackingUrl);
    const campaignCurrency = campaign.get('currency');
    const hashtags = campaign.get('hashtags');
    const campaignStart = campaign.get('liveDate');
    const campaignEnd = campaign.get('endDate');
    const isACR = campaign.get('campaignType') === 'ACR';
    const premiumFeaturesBlocked = campaign.get('premiumFeaturesBlocked');
    const isShopifyCampaign = campaign.get('isShopifyCampaign');
    const isPrestaShopCampaign = campaign.get('isPrestaShopCampaign');

    console.log('isShopifyCampaign', isShopifyCampaign);

    const linkTrackingProps = {
      campaignId,
      campaignName,
      hashtags,
      baseTrackingUrl,
      instagram: _.get(fullInfluencer, 'instagram', null),
    };

    const isUserTeamMember = isUserSuperAdmin || checkUserIsTeamMember(role);

    const stories = _.get(collaboration, 'stories', []);
    const lastScannedDate = _.get(collaboration, 'lastScannedDate', null);
    const internalDiscountCode = _.get(collaboration, 'internalDiscountCode', null);
    const productOrderedDate = _.get(collaboration, 'productOrderedDate', null);
    const shortDiscountLink = _.get(collaboration, 'shortDiscountLink', null);
    const workflowStatus = _.get(collaboration, 'workflowStatus', null);
    const internalOrders = _.get(collaboration, 'internalOrders', null);
    const lastSuccessfulStoryScan = _.get(collaboration, 'lastSuccessfulStoryScan', null);
    const collaborationId = _.get(collaboration, 'id');
    const bioLinkUrl = _.get(collaboration, 'bioLinkUrl');


    const order = _.head(internalOrders);

    let orderDate;

    if (order && order.created_at) {
      orderDate = moment(order.created_at).format('YYYY-MM-DD');
    } else if (productOrderedDate) {
      orderDate = moment(productOrderedDate).format('YYYY-MM-DD');
    }


    const DIVIDER = 'divider';
    const allDropdownOptions = [
      {
        label: 'add facebook post',
        icon: 'facebook',
        value: 'facebook',
        color: 'red',
        onClick: this.toggleAddAssetPopup,
        show: !isACR,
      },
      {
        label: 'add twitter post',
        icon: 'twitter',
        value: 'twitter',
        onClick: this.toggleAddAssetPopup,
        show: !isACR,
      },
      {
        label: 'add instagram post',
        icon: 'instagram',
        value: 'instagram',
        onClick: this.toggleAddAssetPopup,
        show: !isACR,
      },
      {
        label: 'add youtube video',
        icon: 'youtube play',
        value: 'youtube',
        onClick: this.toggleAddAssetPopup,
        show: !isACR,
      },
      {
        label: 'add tiktok video',
        icon: 'tiktok',
        value: 'tiktok',
        onClick: this.toggleAddAssetPopup,
        show: !isACR,
      },
      {
        label: 'add telegram post',
        icon: 'telegram plane',
        value: 'telegram',
        onClick: this.toggleAddAssetPopup,
        show: !isACR,
      },
      {
        label: 'add other posts & stories',
        icon: 'circle outline',
        value: 'story',
        onClick: this.toggleAddStoryModal,
        show: !isACR,
      },
      {
        label: 'view live stories',
        icon: 'eye outline',
        value: 'live-stories',
        onClick: this.toggleViewLiveStoriesModal,
        show: !isACR,
      },
      {
        label: 'view scan history',
        icon: 'list',
        value: 'scan-history',
        onClick: this.toggleScanHistoryModal,
        show: !isACR,
      },
      {
        label: 'ADMIN: mark authorised',
        icon: 'user secret',
        value: 'mark-authorised',
        onClick: this.markAuthorised,
        show: isDyzioUser,
      },
      {
        label: 'SCAN NOW!',
        icon: 'lightning',
        value: 'scan-now',
        onClick: this.scanNow,
        show: !isACR,
      },
      {
        label: 'capture all live stories',
        icon: 'circle',
        value: 'capture-all-stories',
        onClick: this.captureAllStories,
        show: !isACR,
      },
    ];

    const dropdownOptions = _.filter(allDropdownOptions, 'show');

    const budgetProps = isLoadingCollaboration ? { budget: 0 } : {
      budget: collaboration.budget,
      discussionId: collaboration.id,
      saveNewBudget: this.onNewFeeSubmit,
      campaignCurrency,
    };

    const shopifyProps = isLoadingCollaboration ? { discountCode: null, commission: 0 } : {
      discountCode: _.get(collaboration, 'discountCode', null),
      commission: _.get(collaboration, 'commission', 0),
      editable: true,
      saveShopifySetting: this.onShopifySubmit,
      savePrestaShopSetting: this.onShopifySubmit,
      reloadShopifyOrders: this.loadShopify,
      reloadPrestaShopOrders: this.loadShopify,
    };

    const emailProps = isLoadingCollaboration ? { email: '' } : {
      email: fullInfluencer.email,
      saveNewEmail: this.onNewEmailSubmit,
    };

    const toggleAssetTable = () => {
      this.setState({
        hideAssetTable: !hideAssetTable,
      });
    };

    const toggleShopifyTable = () => {
      this.setState({
        hideShopifyTable: !hideShopifyTable,
      });
    };

    const emailToTest = newEmail || _.get(fullInfluencer, 'email', '');
    const isEmailValid = validator.isEmail(emailToTest);

    const instagramId = _.get(fullInfluencer, 'instagramId', '');
    const existingStoriesIDs = _.map(stories, 'assetId');

    const isNTW = organisationId === 'fbc5c905-2084-40dd-b966-7e127db073c8';

    return (
      <div>
        <Grid>
          <Grid.Row>
            <Grid.Column width="4">
              <Card fluid>
                <Card.Content>
                  <DyzioSecondaryButton
                    label="back to campaign"
                    icon={<Icon name="arrow left" />}
                    style={backButtonStyle}
                    hasIcon
                    onClick={this.returnToCampaign}
                    fluid
                  />
                </Card.Content>
              </Card>
              <VerticalInfluencerBar
                {...influencer}
                {...fullInfluencer}
                isLoading={isLoadingCollaboration}
                isLoadingLiveStoriesCount={isLoadingLiveStoriesCount}
                liveStoriesCount={liveStoriesCount}
                onLiveStoriesLabelClick={this.toggleViewLiveStoriesModal}
              />

              <Card fluid>
                <Card.Content textAlign="center">

                  <DyzioPrimaryButton
                    label={nextDiscussionId || hasRolledForward ? 'already rolled' : 'Roll Forward'}
                    icon={<Icon name="arrow alternate circle right" />}
                    style={backButtonStyle}
                    hasIcon
                    onClick={this.toggleRollForwardModal}
                    fluid
                    disabled={nextDiscussionId || hasRolledForward}
                  />

                </Card.Content>
                <Card.Content extra textAlign="center">
                  <p style={smallPrint}>Roll the Influencer forward<br />into the next campaign.</p>
                </Card.Content>

                <Card.Content extra textAlign="center">
                  <p style={smallPrint}>{`This Influencer was ${previousDiscussionId ? 'ROLLED FORWARD' : 'ADDED MANUALLY'}`}</p>
                </Card.Content>

              </Card>

              <Card fluid>
                <Card.Content textAlign="center">
                  <Radio
                    toggle
                    label="is Completed?"
                    name="isScanningCompleted"
                    value={isScanningCompleted}
                    checked={isScanningCompleted}
                    onChange={this.toggleIsScanningCompleted}
                  />
                </Card.Content>
                <Card.Content extra textAlign="center">
                  <p style={smallPrint}>Checking this option will stop the system<br />from scanning this influencer.</p>
                </Card.Content>
              </Card>
              <Card fluid>
                <Card.Content textAlign="center">
                  <Radio
                    toggle
                    label="is Client Discussion"
                    name="isClientDiscussion"
                    value={isClientDiscussion}
                    checked={isClientDiscussion}
                    onChange={this.toggleIsClientDiscussion}
                  />
                </Card.Content>
                <Card.Content extra textAlign="center">
                  <p style={smallPrint}>Checking this option will exclude assets from this disccusion from the reports.</p>
                </Card.Content>
              </Card>
              {
                !isLoadingCollaboration &&
                  <CollaborationEmail
                    {...emailProps}
                  />
              }
              {
                premiumFeaturesBlocked && <BlockedInvitationStatus />
              }
              {
                !premiumFeaturesBlocked && (
                  <Card fluid>
                    <Card.Content>
                      <h3>Invitation Status</h3>
                    </Card.Content>
                    <Card.Content textAlign="center">
                      {
                        isEmailValid
                          ? (
                            <DyzioPrimaryButton
                              label="Send Invitation"
                              icon={<Icon name="mail outine" />}
                              style={backButtonStyle}
                              hasIcon
                              onClick={this.toggleSendInviteModal}
                              fluid
                            />
                          )
                          : (
                            <Label basic color="red">
                              <Icon name="ban" color="red" />
                          set email above
                            </Label>
                          )
                      }

                    </Card.Content>
                    <Card.Content textAlign="center">
                      <InvitationStatus status={localInvitatinStatus || invitationStatus} />
                    </Card.Content>
                  </Card>
                )
              }
              {
                !isLoadingCollaboration &&
                  <CollaborationBudget
                    {...budgetProps}
                  />
              }

              <Card fluid>
                <Card.Content>
                  <h3>Remove Influencer</h3>
                </Card.Content>
                <Card.Content>
                  <DyzioDeleteButton
                    fluid
                    onClick={this.toggleInfluencerDeleteModal}
                  />
                </Card.Content>
              </Card>
            </Grid.Column>
            <Grid.Column width="12" style={{ paddingLeft: 0 }}>
              {
                hasBaseTrackingUrl && <LinkTracking {...linkTrackingProps} />
              }
              { !isLoadingCollaboration && isShopifyCampaign && (organisationId !== 'b847c281-d377-4528-a416-303234e382d8') &&
                <ShopifyConfig {...shopifyProps} />
              }
              { !isLoadingCollaboration && isPrestaShopCampaign &&
                <PrestaShopConfig {...shopifyProps} />
              }
              { !isLoadingCollaboration && isShopifyCampaign &&
                <Card fluid>
                  <Card.Content>
                    <Grid columns="2">
                      <Grid.Row>
                        <Grid.Column verticalAlign="middle">
                          <h3><img
                            src="/icons/shopify.svg"
                            alt="Shopify"
                          /> Shopify Total Sales
                          </h3>
                        </Grid.Column>
                        <Grid.Column textAlign="right">
                          { hideShopifyTable
                            ? <Button floated="right" icon="chevron down" onClick={toggleShopifyTable} style={buttonStyles} />
                            : <Button floated="right" icon="chevron up" onClick={toggleShopifyTable} style={buttonStyles} />
                          }
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>

                  </Card.Content>
                  {
                    !isLoadingCollaboration && !hideShopifyTable && !shopifyLoading &&
                    <Card.Content>
                      <Card.Content>
                        <p>
                        Data will appear in the table below, once the Shopify code or URL have been used by one of your customers.
                        </p>
                        <Divider />
                      </Card.Content>
                      <ShopifyTable
                        orders={shopifyOrders}
                        hasDiscountCodes={!!_.get(collaboration, 'discountCode') || _.get(fullInfluencer, 'discountCodes')}
                      />
                    </Card.Content>
                  }
                  {
                    shopifyLoading &&
                    <Card.Content textAlign="center" style={loadingAssetsCardStyle}>
                      <Icon name="refresh" loading size="huge" />
                      <Divider hidden />
                    Loading Shopify Orders
                    </Card.Content>
                  }
                </Card>
              }
              { !isLoadingCollaboration && isPrestaShopCampaign &&
                <Card fluid>
                  <Card.Content>
                    <Grid columns="2">
                      <Grid.Row>
                        <Grid.Column verticalAlign="middle">
                          <h3><img
                            src="/icons/prestashop.svg"
                            alt="PrestaShop"
                          /> PrestaShop Total Sales
                          </h3>
                        </Grid.Column>
                        <Grid.Column textAlign="right">
                          { hideShopifyTable
                            ? <Button floated="right" icon="chevron down" onClick={toggleShopifyTable} style={buttonStyles} />
                            : <Button floated="right" icon="chevron up" onClick={toggleShopifyTable} style={buttonStyles} />
                          }
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>

                  </Card.Content>
                  {
                    !isLoadingCollaboration && !hideShopifyTable && !shopifyLoading && isPrestaShopCampaign &&
                    <Card.Content>
                      <Card.Content>
                        <p>
                        Data will appear in the table below, once the PrestaShop code or URL have been used by one of your customers.
                        </p>
                        <Divider />
                      </Card.Content>
                      <PrestaShopTable
                        orders={prestaSHopOrders}
                        hasDiscountCodes={!!_.get(collaboration, 'discountCode') || _.get(fullInfluencer, 'discountCodes')}
                      />

                    </Card.Content>
                  }
                  {
                    shopifyLoading && isPrestaShopCampaign &&
                    <Card.Content textAlign="center" style={loadingAssetsCardStyle}>
                      <Icon name="refresh" loading size="huge" />
                      <Divider hidden />
                    Loading PrestaShop Orders
                    </Card.Content>
                  }
                </Card>
              }
              <Card fluid>
                {
                  !isACR && !isLoadingAssets && isUserTeamMember &&
                    <Card.Content>
                      <Grid columns="3">
                        <Grid.Row>
                          <Grid.Column verticalAlign="middle">
                            <h3>Campaign posts
                            </h3>
                            <div style={{ fontSize: '80%', color: 'grey' }}>
                            last GRID scan: {lastScannedDate ? moment(lastScannedDate).fromNow() : 'not scanned yet'}
                            &nbsp;
                              <a
                                rel="noopener noreferrer"
                                href={`${currentTheme.shareSite}/collab/${collaborationId}/campaign`}
                                target="_blank"
                              >
                              open collaboration report...
                              </a>
                            </div>
                            <div style={{ fontSize: '80%', color: 'grey' }}>
                            last STORY scan: {lastSuccessfulStoryScan ? moment(lastSuccessfulStoryScan).fromNow() : 'not scanned yet'}
                            </div>
                          </Grid.Column>
                          <Grid.Column style={{ textAlign: 'center' }}>

                            <Popup
                              content={'This will force the system to scan all platforms NOW for any live content that matches the search criteria.'}
                              trigger={
                                <Button
                                  onClick={this.scanNow}
                                  inverted color="blue"
                                  icon
                                  labelPosition="left"

                                >
                                  <Icon name="binoculars" />
                          SCAN NOW
                                </Button>
                              }
                            />
                          </Grid.Column>
                          <Grid.Column textAlign="right">
                            <Dropdown
                              icon={null}
                              pointing="top right"
                              floating
                              trigger={
                                <Button
                                  inverted
                                  color="pink"
                                  icon
                                  labelPosition="left"
                                >
                                  <Icon name="plus" />
                                Add post
                                </Button>
                              }
                            >
                              <Dropdown.Menu>
                                {
                                  _.map(dropdownOptions, opt => {
                                    if (opt.type === DIVIDER) {
                                      return (<Dropdown.Divider />);
                                    }

                                    if (opt.disabled && opt.popupText) {
                                      return (
                                        <Popup
                                          trigger={
                                            <Dropdown.Item
                                              onClick={_.noop()}
                                              value={opt.value}
                                            >
                                              <Icon name={opt.icon} />{opt.label}
                                            </Dropdown.Item>
                                          }
                                          content={opt.popupText}
                                        />
                                      );
                                    }

                                    return (
                                      <Dropdown.Item
                                        disabled={opt.disabled}
                                        onClick={opt.onClick}
                                        value={opt.value}
                                      >
                                        { opt.icon === 'tiktok' && <img style={tiktokIconStyle} src="https://app.dyzio.co/logos/tiktok-logo.svg" alt="Tiktok" /> }
                                        { opt.icon !== 'tiktok' && <Icon name={opt.icon} /> }{opt.label}
                                      </Dropdown.Item>
                                    );
                                  })
                                }
                              </Dropdown.Menu>
                            </Dropdown>
                            { hideAssetTable
                              ? <Button floated="right" icon="chevron down" onClick={toggleAssetTable} style={buttonStyles} />
                              : <Button floated="right" icon="chevron up" onClick={toggleAssetTable} style={buttonStyles} />
                            }
                          </Grid.Column>
                        </Grid.Row>

                        {internalDiscountCode &&
                        <Grid.Row>
                          <Grid.Column verticalAlign="middle">
                            <h4>Discount Code <Label>{internalDiscountCode}</Label></h4>
                          </Grid.Column>
                          <Grid.Column textAlign="center">
                            {workflowStatus &&
                              <Label basic color="pink"><Icon name="check circle outline" />{workflowStatus}</Label>
                            }
                          </Grid.Column>
                          <Grid.Column verticalAlign="right" >
                            { order &&
                              <Label basic>
                                {_.head(order.line_items).title}<br />
                                <span style={{ color: 'grey' }}>order date: {orderDate || 'UNKNOWN'}</span>
                              </Label>
                            }
                          </Grid.Column>
                        </Grid.Row>
                        }

                        {bioLinkUrl &&
                        <Grid.Row>
                          <Grid.Column verticalAlign="middle" width={12}>
                            <h4>Bio Link URL <Label>{bioLinkUrl}</Label>&nbsp;
                              <Popup
                                trigger={
                                  <Button
                                    circular
                                    icon="copy"
                                    onClick={() => {
                                      navigator.clipboard.writeText(bioLinkUrl);
                                    }}
                                  />
                                } content="Copy Bio Link URL to clipboard"
                              />
                            </h4>
                          </Grid.Column>
                        </Grid.Row>
                        }
                        {isNTW && internalDiscountCode &&
                        <Grid.Row>
                          <Grid.Column verticalAlign="middle">
                            {
                              newShortLink || shortDiscountLink
                                ? <h4>
                                  LINK <Label color="blue">{newShortLink || shortDiscountLink}</Label>
                                  &nbsp;
                                  <Popup
                                    trigger={
                                      <Button
                                        circular
                                        icon="copy"
                                        onClick={() => {
                                          navigator.clipboard.writeText(newShortLink || shortDiscountLink);
                                        }}
                                      />
                                    } content="Copy link to clipboard"
                                  />
                                </h4>
                                : <Button
                                  onClick={this.createDiscountLink}
                                  disable={createDiscountDisabled}
                                  loading={createDiscountLoading}
                                >
                                  Create Discount Link
                                </Button>
                            }

                          </Grid.Column>
                          <Grid.Column textAlign="center" />
                          <Grid.Column verticalAlign="right" >
                            &nbsp;
                          </Grid.Column>
                        </Grid.Row>

                        }
                      </Grid>

                    </Card.Content>
                }
                {
                  !isACR && isLoadingAssets && !hideAssetTable &&
                    <Card.Content textAlign="center" style={loadingAssetsCardStyle}>
                      <Icon name="refresh" loading size="huge" />
                      <Divider hidden />
                  Loading assets
                    </Card.Content>
                }
                {
                  !isACR && !isLoadingAssets && !hideAssetTable &&
                    <Card.Content>
                      <AssetTable
                        toggleAssetLocalState={this.toggleAssetLocalState}
                        campaignName={campaignName}
                        hashtags={hashtags}
                        stories={stories}
                        influencer={fullInfluencer}
                        assets={assetsDetails}
                        deleteAssetHandler={this.removeAsset}
                        campaignType={campaignType}
                        deleteStoryHandler={this.removeStory}
                        hashtags={campaign && campaign.get('hashtags') || []}
                      />
                    </Card.Content>
                }
              </Card>

            </Grid.Column>
          </Grid.Row>
        </Grid>
        {
          asset.adding &&
            <AddAssetForm
              isOverLimit={isOverLimit}
              isOpen={asset.adding}
              platform={asset.platform}
              errors={asset.errors}
              popupToggleHandler={this.toggleAddAssetPopup}
              addAssetHandler={this.assetFormSubmitHandler}
            />
        }
        {
          sendingInvite &&
            <InviteModal2
              thumbnail={influencer.thumbnail}
              closeHandler={this.closeInviteModal}
              sendHandler={this.sendInviteToInfluencer}
              email={emailToTest}
              inviteSentOK={inviteSentOK}
              name={fullInfluencer.name || ''}
              campaignName={campaignName}
              hashtags={hashtags}
              campaignType={campaignType}
              campaignStart={campaignStart}
              campaignEnd={campaignEnd}
            />
        }
        {
          addStoryVisible &&
            <AddStoryModal
              popupToggleHandler={this.toggleAddStoryModal}
              successHandler={this.addStory}
              campaignId={campaign.get('id')}
              discussionId={collaboration.id}
              discussionName={collaboration.name}
            />
        }
        {
          isDeletingInfluencer &&
            <DeleteInfluencerModal
              influencer={influencer}
              campaignName={campaignName}
              onClose={this.toggleInfluencerDeleteModal}
              onConfirm={this.removeCollaboration}
            />
        }
        {
          viewLiveStoriesModalOpen &&
            <StoryPickerModal
              onAddStoryToCollaboration={this.addStoryToCollaboration}
              onClose={this.toggleViewLiveStoriesModal}
              influencerId={_.get(fullInfluencer, 'id')}
              existingStoriesIDs={existingStoriesIDs}
              isAddingStoryToCollab={isAddingStoryToCollab}
            />
        }
        {
          scanHistoryModalOpen &&
            <ScanHistoryModal
              discussionId={collabId}
              onClose={this.toggleScanHistoryModal}
            />
        }

        {
          scanNowModalOpen &&
            <ScanNowModal
              onClose={() => { console.log('close me'); }}
            />
        }
        {
          rollForwardModalOpen &&
            <RollForwardModal
              onClose={this.toggleRollForwardModal}
              loading={rollForwardModal.isSearching}
              visible={rollForwardModal.visible}
              selected={rollForwardModal.selected}
              searchHandler={this.handleRollForwardModalSearch}
              selectedHandler={this.handleOptionsSelected}
              searched={rollForwardModal.searched}
              yepButtonHandler={this.handleRollForwardButton}
              options={rollForwardModal.options}
              isRolling={isRolling}
            />
        }
      </div>
    );
  }
}

Collaboration.propTypes = {
  location: PropTypes.func.isRequired,
  campaign: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  restClient: PropTypes.object.isRequired,
  userInfo: PropTypes.object.isRequired,
  onLoadingCampaign: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
};

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onLoadingCampaign: (campaignId, silent) => dispatch(loadingCampaign(campaignId, silent)),
  };
}

const mapStateToProps = () => ({

});

export default compose(
  hasUserInfo,
  withRouter,
  hasJSONAPIClient,
  hasRESTClient,
  withTrackedAssetsData,
  connect(mapStateToProps, mapDispatchToProps),
)(Collaboration);



/** WEBPACK FOOTER **
 ** ./src/containers/collaboration/index.js
 **/